import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { useMemo } from 'react';
import { To, useNavigate } from 'react-router-dom';

const ABSOLUTE_ROUTE_ROOTS = ['admin', 'collector', 'careadvisor'];

export default function useRoleNavigate() {
  const navigate = useNavigate();
  const { userInfo } = useAppSelector(selectAuth);
  const role = userInfo.role.name;

  const getFirstPathSegment = (path: string): string | null => {
    if (!path) return null;

    return path.split('?')[0].split('#')[0].split('/').filter(Boolean)[0]?.toLowerCase() ?? null;
  };

  return useMemo(() => {
    return (to: To | number, options?: { replace?: boolean; state?: any }) => {
      if (typeof to === 'string') {
        const firstSegment = getFirstPathSegment(to);
        const isAbsoluteAppRoute = firstSegment != null && ABSOLUTE_ROUTE_ROOTS.includes(firstSegment);
        const hasRoleInUrl = firstSegment === role.toLowerCase();

        if (!hasRoleInUrl && !isAbsoluteAppRoute) {
          to = `/${role.toLowerCase()}${to.startsWith('/') ? '' : '/'}${to}`;
        }
        navigate(to, options);
      } else if (typeof to === 'number') {
        // Navigate by history steps; no options allowed
        navigate(to);
      } else {
        // to is Location object
        navigate(to, options);
      }
    };
  }, [navigate, role]);
}
